var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPointer = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5c6671",
  d: "M15.836 13.627L.835.126A.5.5 0 000 .498v20.001a.499.499 0 00.806.394l4.033-3.137 3.22 5.98a.501.501 0 00.664.21l4-2a.501.501 0 00.217-.685l-3.164-5.876 5.8-.893a.5.5 0 00.259-.867zm-6.912.878a.498.498 0 00-.364.731l3.256 6.046-3.106 1.553-3.27-6.074a.5.5 0 00-.748-.158L.998 19.475V1.62L14.38 13.664l-5.458.84z"
})));
export default SvgPointer;